import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import type { AnalyticsTimeseriesPoint } from '@/lib/analytics-api';

interface Props {
  data: AnalyticsTimeseriesPoint[];
}

function formatDay(day: string): string {
  const d = new Date(day);
  return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' });
}

export default function VisitorsChart({ data }: Props) {
  const chartData = data.map((d) => ({ ...d, label: formatDay(d.day) }));

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <h2 className="text-sm font-semibold text-gray-900 mb-4">Besucher & Seitenaufrufe</h2>
      {chartData.length === 0 ? (
        <div className="h-64 flex items-center justify-center text-sm text-gray-400">
          Noch keine Tracking-Daten im Zeitraum.
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={280}>
          <AreaChart data={chartData} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
            <defs>
              <linearGradient id="gVisitors" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#3b82f6" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="gPageviews" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#06b6d4" stopOpacity={0.2} />
                <stop offset="95%" stopColor="#06b6d4" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: '#94a3b8' }} tickLine={false} axisLine={false} minTickGap={20} />
            <YAxis tick={{ fontSize: 11, fill: '#94a3b8' }} tickLine={false} axisLine={false} allowDecimals={false} />
            <Tooltip
              contentStyle={{ fontSize: 12, borderRadius: 8, border: '1px solid #e2e8f0' }}
              labelStyle={{ color: '#475569' }}
            />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Area
              isAnimationActive={false}
              type="monotone"
              dataKey="pageviews"
              name="Seitenaufrufe"
              stroke="#06b6d4"
              strokeWidth={2}
              fill="url(#gPageviews)"
            />
            <Area
              isAnimationActive={false}
              type="monotone"
              dataKey="visitors"
              name="Besucher"
              stroke="#3b82f6"
              strokeWidth={2}
              fill="url(#gVisitors)"
            />
          </AreaChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
